export enum CommandType {
	SURVEY_ENABLE = 'survey_enable',
	SURVEY_DISABLE = 'survey_disable',
	SURVEY_SHOW = 'survey_show',
	SHOW_WIDGET = 'show_widget',
	SHOW_TYPING = 'show_typing',
	MAXIMIZE_CHAT = 'maximize_chat',
	MINIMIZE_CHAT = 'minimize_chat',
	WEB_MESSAGE = 'web_message',
	SET_LANG = 'set_lang',
	CLOSE_CHANNEL = 'close_channel',
}
